import TCartItems from "./TCartItems";
import CartItem from "./CartItem";
import CartError from "./CartError";

import Boards from "../database/Boards";
import IBoardData from "../database/IBoardData";

import MaterialConfigurator from "../paramScript/MaterialConfigurator";
class CartProcessor {

    private map: Map<string, CartItem>;
    private target: HTMLElement;
    private cartJSON: CartItem[];
    private opened: boolean;
    private taxRate: number;

    private id: string;

    private restoreParamsFromCart: (id_cabinet:number, pScript: any, uScript: any) => void;
    private confirmDeleteItemFromCart: (id: number) => void;
    private updateCartQty: (id: number, qty: number) => void;
    private cartQuantityApplied: (id: number) => void;

    // TODO: Type this correctly
    constructor(cartJSON: TCartItems | null
        , taxRate: number
        , restoreParamsFromCart: (id_cabinet:number, pScript: any, uScript: any) => void
        , confirmDeleteItemFromCart: (id: number) => void
        , updateCartQty: (id: number, qty: number) => void
        , cartQuantityApplied: (id: number) => void) {

        this.map = new Map<string, CartItem>();
        this.id = "";
        this.taxRate = taxRate;
        this.restoreParamsFromCart = restoreParamsFromCart;
        this.confirmDeleteItemFromCart = confirmDeleteItemFromCart;
        this.updateCartQty = updateCartQty;
        this.cartQuantityApplied = cartQuantityApplied;

	    if(cartJSON == null)
        {
            this.target = document.createElement("div");
            this.cartJSON = [];
            this.opened = false;
		    return;
        }

        if(cartJSON.hasOwnProperty("error")) {
            const errorJSON = cartJSON as CartError;
            alert("Cart returned an error: (" + errorJSON.error + ") " + errorJSON.message);
            this.target = document.createElement("div");
            this.cartJSON = [];
            this.opened = false;
            return;
        }
        
        this.cartJSON = cartJSON as CartItem[];
        this.target = document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="table"]')!;
        this.opened = true;

        //console.log("CART JSON:");
        //console.log(this.cartJSON);

        // create a map to group the cart elements
        // Going in reverse order, so the last added items will be on top
        for (let cabinet of this.cartJSON.reverse()) {
            this.addToMap(cabinet.Name + JSON.stringify(cabinet.descriptor), cabinet);
        }

        const nameArray: string[] = [];
        for (let cabinet of this.map.values()) {
            let name: string = cabinet.Name;
            let originalName: string = name;
            let count: number = 1;
        
            // Check if the name already exists in the array
            while (nameArray.includes(name)) {
                // If it exists, modify the name by adding a postfix
                name = `${originalName} (${count})`;
                count++;
            }
        
            // Add the (possibly modified) name to the array
            nameArray.push(name);
        }

        this.createHTMLForMobile(nameArray);

        this.target = document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="table"]')!;

        let idx: number = 0;
        let itemCount: number = 0;
        let grandTotal: number = 0;

        for (let cabinet of this.map.values()) {
            //console.log(cabinet);
            itemCount = itemCount + cabinet.count;

            // generate random id using letters only for every cabinet
            this.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 5);

            // having 6 columns in the cart table
            const link: HTMLDivElement = this.createCartLink(nameArray[idx]); // we may replace this
            link.id = this.id;

            const decor: HTMLSpanElement = this.createCartText(""); // empty decor (summary) we may replace this
            this.createCartText(cabinet.Dimensions + "mm");
            const edges = this.createCartText(""); // empty edges (summary) we may replace this
            let cartText = Math.round(cabinet.Price * taxRate) + " Ft";
            // If any of the boards have SheetPrice, then we should display the price as an approximation
            if (cabinet.children.some((board) => board.SheetPrice)) {
                cartText = "~" + cartText;
            }
            this.createCartText(cartText);
            this.createCartInput(String(cabinet.count), { id_cabinet: cabinet.id_cabinet});
            this.createCartActionButtons(cabinet);

            grandTotal += Math.round(cabinet.Price * taxRate) * cabinet.count;
            if(cabinet.children.length > 1) {
                for(let board of cabinet.children) {
                    // having 6 columns in the cart table
                    this.createCartText(board.Name, 20).setAttribute("data-id", this.id);

                    // add duplung icon if applicable
                    let duplungIcon: string = "";
                    if(board.hasOwnProperty("Duplung")) {
                        duplungIcon = '<img style="padding-left: 0.4em; height: 1.5em;" src="/modules/ubercabinet/views/images/duplung.svg" />';
                    }
    
                    const boardProduct: IBoardData | null = Boards.instance!.findByID(board.ProductID);
                    this.createCartText(boardProduct ? boardProduct.Name + duplungIcon : "N/A").setAttribute("data-id", this.id);
                    this.createCartText(board.Width + "x" + board.Height + "mm").setAttribute("data-id", this.id);
                    this.createCartEdgeCheckBoxes(board.Edges).setAttribute("data-id", this.id);
                    // If the board has SheetPrice, then we should display the price as an approximation
                    this.createCartText((board.SheetPrice ? "~" : "") + board.PriceGross + " Ft").setAttribute("data-id", this.id);
                    this.createCartText(cabinet.count + " db").setAttribute("data-id", this.id);
                    this.createEmptyItem().setAttribute("data-id", this.id);
                }
            } else if(cabinet.children.length == 1) {
                // replace openable link/name with a simple text
                const newLink: HTMLSpanElement = this.createCartText(nameArray[idx], { appendToTarget: false });
                newLink.id = this.id;
                link.parentNode!.replaceChild(newLink, link);

                // add duplung icon if applicable
                let duplungIcon: string = "";
                if(cabinet.children[0].hasOwnProperty("Duplung")) {
                    duplungIcon = '<img style="padding-left: 0.4em; height: 1.5em;" src="/modules/ubercabinet/views/images/duplung.svg" />';
                }
                
                // replace item, zero padding and don't append to target!
                const boardProduct: IBoardData | null = Boards.instance!.findByID(cabinet.children[0].ProductID);
                const newDecor: HTMLSpanElement = this.createCartText(boardProduct ? boardProduct.Name + duplungIcon : "N/A", { appendToTarget: false });
                decor.parentNode!.replaceChild(newDecor, decor);

                // replace the placeholder item with edge checkboxes
                const newEdges: HTMLDivElement = this.createCartEdgeCheckBoxes(cabinet.children[0].Edges, { appendToTarget: false });
                edges.parentNode!.replaceChild(newEdges, edges);
            } else {
                console.log("cartprocessor desktop: should it ever happen?");
            }
            idx++;
        }

        document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="item-count"]')!.innerHTML = String(itemCount);
        document.querySelector<HTMLElement>('[data-id="cart-panel"] [data-id="grand-total"]')!.innerHTML = String(grandTotal);
    }

    private createHTMLForMobile(nameArray: string[]): void {
        //this.target = document.querySelector<HTMLElement>('[data-id="cart-panel-mobile"] [data-id="table"]')!;

        let idx: number = 0;
        let itemCount: number = 0;
        let grandTotal: number = 0;

        //this.target = document.querySelector<HTMLElement>('[data-id="cart-panel-mobile"] [data-id="list"]')!;

        for (let cabinet of this.map.values()) {

            // create card element for every main item
            this.target = document.createElement("div");
            this.target.classList.add("card-2");

            itemCount = itemCount + cabinet.count;

            // generate random id using letters only for every cabinet
            this.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 5);

            this.createCartText("NÉV:", { bold: true });
            const link: HTMLDivElement = this.createCartLink(nameArray[idx]);
            link.id = this.id;

            this.createCartText("ANYAG:", { bold: true });
            const decor: HTMLSpanElement = this.createCartText("-"); // empty decor (summary)
            
            this.createCartText("MÉRET:", { bold: true });
            this.createCartText(cabinet.Dimensions + "mm");

            this.createCartText("ÉLZÁRÁS:", { bold: true });
            const edges: HTMLSpanElement = this.createCartText("-"); // empty edges (summary)
            
            this.createCartText("ÁR:", { bold: true });
            this.createCartText(Math.round(cabinet.Price * this.taxRate) + " Ft");
            
            this.createCartText("MENNYISÉG:", { bold: true });
            this.createCartText(cabinet.count + " db");

            this.createCartText("MŰVELETEK:", { bold: true });
            this.createCartActionButtons(cabinet);

            grandTotal += Math.round(cabinet.Price * this.taxRate) * cabinet.count;

            // find the list and append the card to it
            document.querySelector<HTMLElement>('[data-id="cart-panel-mobile"] [data-id="list"]')!.appendChild(this.target);

            if(cabinet.children.length > 1) {
                for(let board of cabinet.children) {
                    // having 6 columns in the cart table

                    this.target = document.createElement("div");
                    this.target.classList.add("card-2");
                    this.target.setAttribute("data-id", this.id);
                    const boardProduct: IBoardData | null = Boards.instance!.findByID(board.ProductID);

                    this.createCartText("NÉV:", { bold: true, padLeft: 10 });
                    this.createCartText(board.Name);

                    // add duplung icon if applicable
                    let duplungIcon: string = "";
                    if(board.hasOwnProperty("Duplung")) {
                        duplungIcon = '<img style="padding-left: 0.4em; height: 1.5em;" src="/modules/ubercabinet/views/images/duplung.svg" />';
                    }

                    this.createCartText("ANYAG:", { bold: true, padLeft: 10 });
                    this.createCartText(boardProduct ? boardProduct.Name + duplungIcon : "N/A");
                    this.createCartText("MÉRET:", { bold: true, padLeft: 10 });
                    this.createCartText(board.Width + "x" + board.Height + "mm");
                    this.createCartText("ÉLZÁRÁS:", { bold: true, padLeft: 10 });
                    this.createCartEdgeCheckBoxes(board.Edges);
                    this.createCartText("ÁR:", { bold: true, padLeft: 10 });
                    this.createCartText(Math.round(board.Price * this.taxRate) + " Ft");
                    this.createCartText("MENNYISÉG:", { bold: true, padLeft: 10 });
                    this.createCartText(cabinet.count + " db");

                    document.querySelector<HTMLElement>('[data-id="cart-panel-mobile"] [data-id="list"]')!.appendChild(this.target);
                }
            } else if(cabinet.children.length == 1) {
                // replace openable link/name with a simple text
                const newLink: HTMLSpanElement = this.createCartText(nameArray[idx], { appendToTarget: false });
                newLink.id = this.id;
                link.parentNode!.replaceChild(newLink, link);

                // add duplung icon if applicable
                let duplungIcon: string = "";
                if(cabinet.children[0].hasOwnProperty("Duplung")) {
                    duplungIcon = '<img style="padding-left: 0.4em; height: 1.5em;" src="/modules/ubercabinet/views/images/duplung.svg" />';
                }

                // replace item, zero padding and don't append to target!
                const boardProduct: IBoardData | null = Boards.instance!.findByID(cabinet.children[0].ProductID);
                const newDecor: HTMLSpanElement = this.createCartText(boardProduct ? boardProduct.Name + duplungIcon : "N/A", { appendToTarget: false });
                decor.parentNode!.replaceChild(newDecor, decor);

                // replace the placeholder item with edge checkboxes
                const newEdges: HTMLDivElement = this.createCartEdgeCheckBoxes(cabinet.children[0].Edges, { appendToTarget: false });
                edges.parentNode!.replaceChild(newEdges, edges);
            } else {
                console.log("cartprocessor mobile: should it ever happen?");
            }

            idx++;
        }

        document.querySelector<HTMLElement>('[data-id="cart-panel-mobile"] [data-id="item-count"]')!.innerHTML = String(itemCount);
        document.querySelector<HTMLElement>('[data-id="cart-panel-mobile"] [data-id="grand-total"]')!.innerHTML = String(grandTotal);
    }

    public isCartEmpty(): boolean {
        return this.cartJSON.length == 0;
    }

    private addToMap(key: string, obj: CartItem): void {
        if(this.map.has(key)) {
            let existingObj: CartItem = this.map.get(key)!;
            existingObj.count = existingObj.count + 1;
        } else {
            this.map.set(key, obj);
        }
    }

    public findCabinetByContent(cabinet: CartItem): CartItem | null {
        const key: string = cabinet.Name + JSON.stringify(cabinet.descriptor);
        if(this.map.has(key)) {
            return this.map.get(key)!;
        }
        return null;
    }

    private createCartLink(txt: string, options: any = {}): HTMLDivElement {

        const { padLeft = 0, bold = false } = options;

        const div: HTMLDivElement = document.createElement("div");
        div.classList.add("flex-center");
        //div.classList.add("non-selectable");
        div.style.paddingLeft = padLeft + "px";
        if(bold) {
            div.style.fontWeight = "bold";
        }

        const indicator: HTMLSpanElement = document.createElement("span");
        indicator.innerHTML = this.opened ? "▼" : "►";

        const spanBtn: HTMLSpanElement = document.createElement("span");
        spanBtn.innerHTML = txt;
        spanBtn.style.color = "blue";
        spanBtn.style.cursor = "pointer";

        let opened: boolean = true;

        spanBtn.addEventListener("click", () => {
            if (opened) {
                indicator.innerHTML = "►";
                opened = false;
            } else {
                indicator.innerHTML = "▼";
                opened = true;
            }
            this.updateChildElements(div.id);
            console.log("cart link clicked: " + div.id);
        }); 

        div.appendChild(indicator);
        div.appendChild(spanBtn);
        this.target.appendChild(div);
        return div;
    }

    private createCartText(txt: string, options: any = {}): HTMLSpanElement {
        const { padLeft = 0, bold = false, appendToTarget = true } = options;
        const span: HTMLSpanElement = document.createElement("span");
        span.innerHTML = txt;
        span.classList.add("flex-center");
        //span.classList.add("non-selectable");
        span.style.paddingLeft = padLeft + "px";
        if(bold) {
            span.style.fontWeight = "bold";
        }
        if(appendToTarget) {
            this.target.appendChild(span);
        }
        return span;
    }

    private createCartInput(txt: string, options: any = {}): HTMLDivElement {
        const { padLeft = 0, bold = false, appendToTarget = true, id_cabinet = -1 } = options;

        const div: HTMLDivElement = document.createElement("div");
        div.classList.add("flex-center");

        const input: HTMLInputElement = document.createElement("input");
        input.id = id_cabinet;
        input.classList.add("cart-input");
        input.style.width = "25%";
        input.type = "number";
        input.value = txt;
        input.style.paddingLeft = padLeft + "px";

        const span: HTMLSpanElement = document.createElement("span");
        span.innerHTML = " db";

        div.appendChild(input);
        div.appendChild(span);

        input.addEventListener('change', (event: Event) => {
            const target = event.target! as HTMLInputElement;
            console.log("input changed: " + target.value);
            const val: number = parseInt(target.value);
            if(isNaN(val) || val < 0) {
                input.value = String(1);
            } else {
                input.value = String(val);
            }
            this.updateCartQty(id_cabinet, val);
        });

        // Send apply event when the input is applied with Enter key
        input.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Enter' && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey) { // Ignore modifier keys
                event.preventDefault(); // Prevent default action of Enter key
                this.cartQuantityApplied(id_cabinet);
            }
        });

        if(bold) {
            input.style.fontWeight = "bold";
        }
        if(appendToTarget) {
            this.target.appendChild(div);
        }
        return div;
    }

    private createCartEdgeCheckBoxes(edges: any, options: any = {}): HTMLDivElement {
        const { padLeft = 0, bold = false, appendToTarget = true } = options;
        const div: HTMLDivElement = document.createElement("div");
        div.style.paddingRight = "2em";
        div.style.height = "auto";
        div.style.minHeight = "1.8em";
        div.classList.add("flex-center");
        let state = this.getStatusFromEdge(edges.Top);
        div.innerHTML += '<div class="flex-center"><label class="disabled">E:</label><input id="T" type="checkbox" ' + state + ' disabled data-id="T" /></div>';
        state = this.getStatusFromEdge(edges.Bottom);
        div.innerHTML += '<div class="flex-center"><label class="disabled">H:</label><input id="B" type="checkbox" ' + state + ' disabled data-id="B" /></div>';
        state = this.getStatusFromEdge(edges.Left);
        div.innerHTML += '<div class="flex-center"><label class="disabled">B:</label><input id="L" type="checkbox" ' + state + ' disabled data-id="L" /></div>';
        state = this.getStatusFromEdge(edges.Right);
        div.innerHTML += '<div class="flex-center"><label class="disabled">J:</label><input id="R" type="checkbox" ' + state + ' disabled data-id="R" /></div>';
        if(appendToTarget) {
            this.target.appendChild(div);
        }
        return div;
    }

    private createCartActionButtons(cabinet: CartItem): HTMLDivElement {
        const div: HTMLDivElement = document.createElement("div");
        div.classList.add("flex-center");

        const a0: HTMLAnchorElement = document.createElement("a");
        a0.href = "#";
        a0.classList.add("material-symbols-outlined");
        //a0.classList.add("non-selectable");
        a0.innerHTML = "edit";
        a0.onclick = () => {
            // restore paramScriptProc first
            this.restoreParamsFromCart(cabinet.id_cabinet, cabinet.descriptor, cabinet.uconScript);
        };
        div.appendChild(a0);

        const a1: HTMLAnchorElement = document.createElement("a");
        a1.href = "#";
        a1.classList.add("material-symbols-outlined");
        //a1.classList.add("non-selectable");
        a1.innerHTML = "delete";
        a1.onclick = () => {
            this.confirmDeleteItemFromCart(cabinet.id_cabinet);
            //deleteItemFromCart(cabinet.id_cabinet);
        };
        div.appendChild(a1);
        
        this.target.appendChild(div);
        return div;
    }

    private createEmptyItem(height?: number): HTMLDivElement {
        const div = document.createElement("div");
        div.classList.add("flex-center");
        if (height) {
            div.style.height = height + "em";
        }
        this.target.appendChild(div);
        return div;
    }

    private getStatusFromEdge(edge: any): string {
        if(edge && edge.ProductID != MaterialConfigurator.ZERO_GUID) {
            return " checked ";
        }
        return "";
    }

    private updateChildElements(id: string): void {
        const elems: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('[data-id="' + id + '"]');
        for(let elem of elems) {
            elem.classList.toggle("hidden");
        }
    }

}

export default CartProcessor;
